var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15062_6085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0031 0C8.96313 0 3.20312 5.76 3.20312 12.8C3.20312 18.24 6.56313 22.72 11.2031 24.64V32L16.0031 28.8L20.8031 32V24.64C25.4431 22.72 28.8031 18.08 28.8031 12.8C28.8031 5.76 23.0431 0 16.0031 0ZM24.0031 14.4H22.2431C22.0831 15.04 21.9231 15.52 21.6031 16L22.8831 17.28L20.6431 19.52L19.2031 18.24C18.7231 18.56 18.0831 18.72 17.6031 18.88V20.8H14.4031V19.04C13.7631 18.88 13.2831 18.72 12.8031 18.4L11.5231 19.68L9.28312 17.44L10.5631 16C10.2431 15.52 9.92313 15.04 9.76313 14.4H8.00313V11.2H9.76313C9.92313 10.56 10.0831 10.08 10.4031 9.6L9.28312 8.32L11.5231 6.08L12.8031 7.36C13.2831 7.04 13.9231 6.88 14.4031 6.72V4.8H17.6031V6.56C18.2431 6.72 18.7231 6.88 19.2031 7.2L20.4831 5.92L22.7231 8.16L21.4431 9.6C21.7631 10.08 21.9231 10.72 22.0831 11.2H24.0031V14.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9969 15.9996C17.7642 15.9996 19.1969 14.5669 19.1969 12.7996C19.1969 11.0323 17.7642 9.59961 15.9969 9.59961C14.2296 9.59961 12.7969 11.0323 12.7969 12.7996C12.7969 14.5669 14.2296 15.9996 15.9969 15.9996Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15062_6085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.eca3d115e1366ced832e41cc3de573a5.svg";
export { ForwardRef as ReactComponent };